module.exports = __webpack_public_path__ + "PeBN-nJUPb_WsGYCw/RDC_RED_Logo_House.svg";